export const AgeEmptyState = () => (
  <div className="flex h-[280px] min-w-[280px] flex-[1_1_320px] flex-col items-center justify-center gap-3 rounded-12 border border-neutral-100 bg-neutral-25 p-4">
    <div className="flex flex-col items-center justify-center gap-2 text-center">
      <img
        src="/images/talent-charts/age_chart.png"
        alt="Age distribution chart"
        className="h-[40px] w-[48px]"
      />
      <p className="text-14 font-500 text-root-text-color-muted">
        Age distribution
      </p>
      <p className="text-12 font-400 text-root-text-color-subtle">
        Chart data is temporarily unavailable
      </p>
    </div>
  </div>
);
